import { UseProvidedAuthInterface } from "../../../../hooks";
import {
  CommitteeEmployee,
  Committee,
  CommitteeTypeEnum,
  CommitteeStatus,
} from "../../../../models/Committee";
import { CommitteeDecision } from "../../../../models/Request";
import { UuidUtils } from "../../../../utils";
import { TabConfig } from "../types";
import {
  checkIsCommitteeMemberOrPresident,
  getAllowedRolesForEditingDecision,
} from "./committee-permissions.util";
import { formatDateRange } from "./formatting.util";

export const findDecisionForCommittee = (
  committee: CommitteeEmployee,
  committeeDecisions: CommitteeDecision[]
): CommitteeDecision | undefined =>
  committeeDecisions?.find(
    (decision) => decision.committeeEmployee?.id === committee.id
  );

export const prepareCommitteeDecisions = (
  committeeDecisions: CommitteeDecision[]
): CommitteeDecision[] => {
  return committeeDecisions.map((committeeDecision) => ({
    ...committeeDecision,
    committeeEmployee: committeeDecision.committeeEmployee?.employee
      ? {
          ...committeeDecision.committeeEmployee,
          rowKeyId: UuidUtils.generateUuid(),
        }
      : committeeDecision.committeeEmployee,
  }));
};

export const createTabConfigs = (committees?: Committee[]): TabConfig[] => {
  if (!committees) return [];

  return committees.map((committee) => ({
    key: committee.id.toString(),
    title: formatDateRange(committee.dateFrom, committee.dateTo),
    employees: committee.employees || [],
    isActive: committee.statusId === CommitteeStatus.Granted,
  }));
};

export const checkIsCommitteeInactive = (
  committees: Committee[] | undefined,
  committeeEmployee: CommitteeEmployee
) => {
  const activeCommittee = findActiveCommittee(committees, committeeEmployee);
  return activeCommittee?.statusId === CommitteeStatus.Inactive;
};

function findActiveCommittee(
  committees: Committee[] | undefined,
  committeeEmployee: CommitteeEmployee
): Committee | undefined {
  return committees?.find(
    (committee) => committee.id === committeeEmployee.committeeId
  );
}

export function hasAllowedRoleForEditing(
  committeeType: CommitteeTypeEnum,
  auth: UseProvidedAuthInterface
) {
  return getAllowedRolesForEditingDecision(committeeType).includes(
    auth.currentRole?.role || 0
  );
}
